
<div class="re-form-item-container">
  <h4 class="re-mb-10">{{ 'tmh.consumption.heading' | translate }}</h4>
  <div class="bold re-mb-20">{{ 'tmh.consumption.description' | translate }}</div>
</div>

<div [formGroup]="parentForm">
  <fieldset name="manufacturer">
    <div class="re-form-item-container">
      <bdo-input [formControl]="parentForm.controls.manufacturer"
        ngDefaultControl
        [inputType]="INPUT_TYPE.TEXT"
        [labelText]="'tmh.consumption.producer' | translate"
        [enableAutocomplete]="true"
        [id]="'manufacturer'"
        (blur)="updateCarModels(parentForm.controls.manufacturer.value)"
        #manufacturer>
      </bdo-input>
      @if (manufacturers$) {
        <bdo-autosuggest
          [dataSource$]="manufacturers$"
          [searchString$]="manufacturerSearchString$"
          [for]="manufacturer"
          [sort]="Utilities.sortAutosuggest"
          [showOffset]="-1"
          (itemSelected)="onManufacturerSelected($event)">
        </bdo-autosuggest>
      }
    </div>
    <div class="re-form-item-container">
      <bdo-input [formControl]="parentForm.controls.carmodel"
        ngDefaultControl
        [inputType]="INPUT_TYPE.TEXT"
        [labelText]="'tmh.consumption.model' | translate"
        [enableAutocomplete]="true"
        [id]="'carmodel'"
        (blur)="onModelSelected(parentForm.controls.carmodel.value)"
        #carmodel>
      </bdo-input>
      @if (carmodels$) {
        <bdo-autosuggest
          [dataSource$]="carmodels$"
          [searchString$]="carmodelSearchString$"
          [for]="carmodel"
          [sort]="Utilities.sortAutosuggest"
          [showOffset]="-1"
          [extraOptionAlwaysVisible]="'tmh.consumption.modelnotfound' | translate"
          (itemSelected)="onModelSelected($event)">
        </bdo-autosuggest>
      }
      @if (compatibilityYear()) {
        <div class="re-mt-20 re-text-sm">
          <ul class="bdo-list__bullet">
            <li>
              <span class="re-mr-10">{{'tmh.consumption.compatibilitytext' | translate: {year:compatibilityYear()} }}</span>
              <bdo-inline-tooltip>
                <span>{{'tmh.consumption.compatibility.info' | translate}}</span>
              </bdo-inline-tooltip>
            </li>
          </ul>
        </div>
      }
    </div>

    @if (compatibilityQuestionable) {
      <div class="re-form-item-container">
        <bdo-input [formControl]="parentForm.controls.wallbox"
          ngDefaultControl
          [inputType]="INPUT_TYPE.TEXT"
          [labelText]="'tmh.consumption.wallbox' | translate"
          [enableAutocomplete]="true"
          [id]="'wallbox'"
          (blur)="onWallboxSelected(parentForm.controls.wallbox.value)"
          #wallbox>
        </bdo-input>
        @if (wallboxes$) {
          <bdo-autosuggest
            [dataSource$]="wallboxes$"
            [searchString$]="wallboxesSearchString$"
            [for]="wallbox"
            [sort]="Utilities.sortAutosuggest"
            [showOffset]="-1"
            [extraOptionAlwaysVisible]="'tmh.consumption.wallboxNotFound' | translate"
            (itemSelected)="onWallboxSelected($event)">
          </bdo-autosuggest>
        }
      </div>
    }

    <div class="re-form-item-container">

      @if (parentForm.controls.manufacturer.value?.length > 0 && parentForm.controls.carmodel.value?.length > 0 && incompatibilityShown) {
        <div
          class="re-mt-20">
          <bdo-info-box [type]="'warning'">
            <div class="re-mb-15"> {{'tmh.consumption.incompatible' | translate }} </div>
            <div class="re-mb-10">
              <bdo-text-link-icon
                [linkText]="'tmh.consumption.incompatibleContact' | translate"
                [href]="reBaseData.hrefChargeFlexManufacturers"
                [iconPosition]="'right'"
                [openInNewTab]="true"
                [tracking]="[TRACKING.LOCATION.CHARGEFLEX, TRACKING.ACTION.GOTO, 'Kontaktdaten hinterlegen']"
              ></bdo-text-link-icon>
            </div>
          </bdo-info-box>
        </div>
      }
    </div>
  </fieldset>
</div>
